import React, { FC } from 'react';
import { cx } from 'emotion';
import Textarea, { TextareaAutosizeProps } from 'react-textarea-autosize';
import { useMultilineStyles } from './styles';

export interface MultilineTextFieldProps
  extends Omit<TextareaAutosizeProps, 'ref'> {
  className?: string;
}

const MultilineTextField: FC<MultilineTextFieldProps> = ({
  className,
  ...props
}) => {
  const styles = useMultilineStyles();

  return (
    <Textarea
      className={className ? cx(className, styles.textField) : styles.textField}
      {...props}
    />
  );
};

export default MultilineTextField;
